"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcModal = void 0;
var util_1 = require("@aperza/util");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcModalContext_1 = require("./AcModalContext");
var AcModal = function (props) {
    var _a;
    var children = props.children, staticBackdrop = props.staticBackdrop, _b = props.level, level = _b === void 0 ? 1 : _b, header = props.header, footer = props.footer, headerCloseButton = props.headerCloseButton, modalProps = __rest(props, ["children", "staticBackdrop", "level", "header", "footer", "headerCloseButton"]);
    var _c = __read(react_1.useState(util_1.UUIDUtil.uuid()), 1), modalId = _c[0];
    var _d = __read(react_1.useState(false), 2), internalShow = _d[0], setInternalShow = _d[1];
    var onHide = modalProps.onHide, size = modalProps.size, style = modalProps.style, _e = modalProps.show, show = _e === void 0 ? false : _e, useShowDirectly = modalProps.useShowDirectly, _f = modalProps.centered, centered = _f === void 0 ? true : _f, dialogAs = modalProps.dialogAs, dialogClassName = modalProps.dialogClassName, backdropClassName = modalProps.backdropClassName, 
    // todo : refactor all <AcModal /> component to use non-white content
    _g = modalProps.contentVariant, 
    // todo : refactor all <AcModal /> component to use non-white content
    contentVariant = _g === void 0 ? 'white' : _g, contentClassName = modalProps.contentClassName;
    var _h = AcModalContext_1.useAcModalContext(), onShowModal = _h.onShowModal, onHideModal = _h.onHideModal;
    var modalLevelClass = level >= 2 ? "aperza-app-modal-" + level + " " : '';
    var dialogLevelClass = level >= 2 ? "aperza-app-dialog-" + level + " " : '';
    var backdropLevelClass = level >= 2 ? "aperza-app-backdrop-" + level + " " : '';
    react_1.useEffect(function () {
        if (show && !internalShow) {
            onShowModal === null || onShowModal === void 0 ? void 0 : onShowModal(modalId);
            setInternalShow(show);
        }
        else if (!show && internalShow) {
            onHideModal === null || onHideModal === void 0 ? void 0 : onHideModal(modalId);
            setInternalShow(show);
        }
    }, [internalShow, modalId, onHideModal, onShowModal, show]);
    // For UNMOUNTED case
    react_1.useEffect(function () {
        return function () {
            onHideModal === null || onHideModal === void 0 ? void 0 : onHideModal(modalId);
        };
    }, [modalId, onHideModal]);
    var renderHeader = function () {
        if (typeof header === 'string') {
            return react_1.default.createElement(react_bootstrap_1.Modal.Title, null, header);
        }
        return header;
    };
    return (react_1.default.createElement(react_bootstrap_1.Modal, __assign({}, modalProps, { show: useShowDirectly ? show : internalShow, onHide: onHide, bsPrefix: modalLevelClass + "aperza-app-modal", dialogAs: dialogAs, dialogClassName: "aperza-app-dialog aperza-app " + dialogLevelClass + (dialogClassName != null ? dialogClassName : ''), backdropClassName: "aperza-app-backdrop " + backdropLevelClass + (backdropClassName != null ? backdropClassName : ''), size: size, "aria-labelledby": "contained-modal-title-vcenter", centered: centered, style: style, backdrop: staticBackdrop ? 'static' : undefined, contentClassName: clsx_1.default(contentClassName, (_a = {},
            _a["bg-" + contentVariant] = contentVariant,
            _a)) }),
        header && react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: headerCloseButton }, renderHeader()),
        !!header || !!footer ? react_1.default.createElement(react_bootstrap_1.Modal.Body, null, children) : children,
        footer && (react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "d-flex align-items-center justify-content-center" }, footer))));
};
exports.AcModal = AcModal;
exports.AcModal.displayName = 'AcModal';
//# sourceMappingURL=AcModal.js.map